import styled from "styled-components";

export const TriggerButton = styled.button`
    background: ${props =>
        props.disabled ? "rgba(112, 101, 93, 0.25) !important" : props.theme.primary};
    color: ${props => props.theme.tertiary};
    max-width: 120px;
    padding: 0.5em;
    font: inherit;
    font-size: 13px;
    align-items: center;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    border: none;
    outline: none;
`;
